<template>
  <div class="riskPointDiaBox">
    <el-dialog title="风险评价" :visible.sync="outerVisble" width="30%" @close="closeOutDia">
      <el-form :model="form" ref="form" label-width="120px" size="small">
        <!-- 固有风险 -->
        <el-form-item label="风险矩阵法 LS：" v-if="checkMethods('LS', 0)">
          <el-tag v-if="assessmentObj.content.inherentRisk.lsvalue === 4" size="small" type="info">未评估</el-tag>
          <el-tag v-else-if="assessmentObj.content.inherentRisk.lsvalue === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.inherentRisk.lsvalue === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.inherentRisk.lsvalue === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.inherentRisk.lsvalue === 3" size="small" effect="dark">低风险</el-tag>
          <el-button size="mini" class="assBtn" @click="lsBtn">评价</el-button>
        </el-form-item>
        <!-- 其它风险 -->
        <el-form-item label="风险矩阵法 LS：" v-if="checkMethods('LS', 1)">
          <el-tag v-if="assessmentObj.content.lsValue === 4" size="small" type="info">未评估</el-tag>
          <el-tag v-else-if="assessmentObj.content.lsValue === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.lsValue === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.lsValue === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.lsValue === 3" size="small" effect="dark">低风险</el-tag>
          <el-button size="mini" class="assBtn" @click="lsBtn">评价</el-button>
        </el-form-item>
        <el-form-item label="风险程度分析法 MES：" v-if="checkMethods('MES')">
          <el-tag v-if="assessmentObj.content.mesValue === 4" size="small" type="info">未评估</el-tag>
          <el-tag v-else-if="assessmentObj.content.mesValue === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.mesValue === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.mesValue === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.mesValue === 3" size="small" effect="dark">低风险</el-tag>
          <el-button size="mini" class="assBtn" @click="innerVisibleMES = true">评价</el-button>
        </el-form-item>
        <el-form-item label="作业条件危险性分析法 LEC：" v-if="checkMethods('LEC')">
          <el-tag v-if="assessmentObj.content.lecValue === 4" size="small" type="info">未评估</el-tag>
          <el-tag v-else-if="assessmentObj.content.lecValue === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.lecValue === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.lecValue === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
          <el-tag v-else-if="assessmentObj.content.lecValue === 3" size="small" effect="dark">低风险</el-tag>
          <el-button size="mini" class="assBtn" @click="innerVisibleLEC = true">评价</el-button>
        </el-form-item>
        <el-form-item label="复评时间">
          <el-date-picker v-model="form.nextEvaluationTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" />
        </el-form-item>
      </el-form>
      <!-- 弹窗里面的评估方法弹窗 -->
      <!-- 风险矩阵法 LS： -->
      <el-dialog title="风险矩阵法 LS：" :visible.sync="innerVisibleLS" @close="closeDiaLS" :fullscreen="true" append-to-body>
        <div>
          <el-button type="primary" size="small" @click="closeDiaLS">确定</el-button>
        </div>
        <Table border :columns="LStableData" :data="assessmentObj.content.ls" style="margin-top: 1%">
          <template slot-scope="{ row }" slot="l">
            <InputNumber
              :max="5"
              :min="0"
              v-model="row.l"
              style="margin-left: -12%"
              @on-change="lChange(row)"
            />
          </template>
          <template slot-scope="{ row }" slot="s">
            <InputNumber
              :max="5"
              :min="0"
              v-model="row.s"
              style="margin-left: -12%"
              @on-change="lChange(row)"
            />
          </template>
          <template slot-scope="{ row }" slot="ls">
            {{ row.ls }}
          </template>
          <template slot-scope="{ row }" slot="standard">
            <span>{{ newMap.get(row.ls.toString()) }}</span>
          </template>
          <template slot-scope="{ row }" slot="riskLevel">
            <el-tag v-if="row.riskLevel === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 3" size="small" effect="dark">低风险</el-tag>
          </template>
          <template slot-scope="{ row }" slot="isControl">
            <el-switch
              v-model="row.isControl"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
              @change="switchChange(row, 'ls')"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </Table>
        <div style="margin-top: 60px;width: 100%">
          <el-table
            :data="tableDataLS"
            border
            :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%;margin-right: 15px">
            <el-table-column prop="" label="发生事故的可能性（L）">
              <el-table-column prop="level" label="等级" width="50px" />
              <el-table-column prop="standard" label="标准" width="850px" />
            </el-table-column>
            <el-table-column prop="" label="事件后果严重性（S）">
              <el-table-column prop="a" label="等级" width="50px" />
              <el-table-column prop="b" label="法律、法规及其他要求"/>
              <el-table-column prop="c" label="人员"/>
              <el-table-column prop="d" label="直接经济损失"/>
              <el-table-column prop="e" label="停工"/>
              <el-table-column prop="f" label="企业形象"/>
            </el-table-column>
          </el-table>
          <!-- <el-table
            :data="tableDataLS2"
            border
            :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 30%;margin-left: 15px">
            <el-table-column prop="" label="事件后果严重性（S）">
              <el-table-column prop="a" label="等级" width="50px" />
              <el-table-column prop="b" label="法律、法规及其他要求"/>
              <el-table-column prop="c" label="人员"/>
              <el-table-column prop="d" label="直接经济损失"/>
              <el-table-column prop="e" label="停工"/>
              <el-table-column prop="f" label="企业形象"/>
            </el-table-column>
          </el-table> -->
        </div>
      </el-dialog>

      <!-- 风险程度分析法 MES： -->
      <el-dialog title="风险矩阵法 MES：" :visible.sync="innerVisibleMES" @close="closeDiaMES" :fullscreen="true" append-to-body>
        <div>
          <el-button type="primary" size="small" @click="closeDiaMES">确定</el-button>
        </div>
        <Table border :columns="MEStableData" :data="assessmentObj.content.mes" style="margin-top: 1%">
          <template slot-scope="{ row }" slot="M">
            <InputNumber
              :max="5"
              :min="0"
              v-model="row.m"
              style="margin-left: -12%"
              @on-change="mesChange(row)"
            ></InputNumber>
          </template>
          <template slot-scope="{ row }" slot="E">
            <InputNumber
              :max="10"
              :min="0"
              v-model="row.e"
              style="margin-left: -12%"
              @on-change="mesChange(row)"
            ></InputNumber>
          </template>
          <template slot-scope="{ row }" slot="S">
            <InputNumber
              :max="10"
              :min="0"
              v-model="row.s"
              style="margin-left: -12%"
              @on-change="mesChange(row)"
            ></InputNumber>
          </template>
          <template slot-scope="{ row }" slot="standard">
            <span v-if="row.mes <= 50">四级</span>
            <span v-if="row.mes > 50 && row.mes <= 90">三级</span>
            <span v-if="row.mes > 90 && row.mes <= 180">二级</span>
            <span v-if="row.mes > 180">一级</span>
          </template>
          <template slot-scope="{ row }" slot="riskLevel">
            <el-tag v-if="row.riskLevel === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 3" size="small" effect="dark">低风险</el-tag>
          </template>
          <template slot-scope="{ row }" slot="isControl">
            <el-switch
              v-model="row.isControl"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
              @change="switchChange(row, 'mes')"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </Table>
        <div class="mesTableBox">
          <div>
            <h3>状态（M）表</h3>
            <el-table
              :data="tableDataMES1"
              border
              :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
              :cell-style="{ textAlign: 'center' }"
              style="width: 100%">
              <el-table-column prop="score" label="分数值" width="150px" />
              <el-table-column prop="status" label="控制措施的状态"/>
            </el-table>
          </div>
          <div>
            <h3>人体暴露或危险状态出现的频繁程度表（E）</h3>
            <el-table
              :data="tableDataMES2"
              border
              :span-method="spanMethodMES1"
              :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
              :cell-style="{ textAlign: 'center' }"
              style="width: 100%">
              <el-table-column prop="score" label="分数值" width="150px" />
              <el-table-column prop="a" label="人体暴露于危险状态的频繁程度"/>
              <el-table-column prop="b" label="危险状态出现的频次" />
            </el-table>
          </div>
          <div>
            <h3>事故的可能后果严重性（S）判定准则</h3>
            <el-table
              :data="tableDataMES3"
              border
              :span-method="spanMethodMES2"
              :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
              :cell-style="{ textAlign: 'center' }"
              style="width: 100%">
              <el-table-column prop="score" label="分数值" width="150px" />
              <el-table-column prop="" label="事故的可能后果">
                <el-table-column prop="a" label="伤害" />
                <el-table-column prop="b" label="职业相关病症" />
                <el-table-column prop="c" label="财产损失（元）" />
                <el-table-column prop="d" label="环境影响" />
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>

      <!-- 作业条件危险性分析法 LEC： -->
      <el-dialog title="风险矩阵法 LEC：" :visible.sync="innerVisibleLEC" @close="closeDiaLEC" :fullscreen="true" append-to-body>
        <div>
          <el-button type="primary" size="small" @click="closeDiaLEC">确定</el-button>
        </div>
        <Table border :columns="LECtableData" :data="assessmentObj.content.lec" style="margin-top: 1%">
          <template slot-scope="{ row }" slot="L">
            <InputNumber
              :max="10"
              :min="0"
              v-model="row.l"
              style="margin-left: -12%"
              @on-change="lecChange(row)"
            ></InputNumber>
          </template>
          <template slot-scope="{ row }" slot="E">
            <InputNumber
              :max="10"
              :min="0"
              v-model="row.e"
              style="margin-left: -12%"
              @on-change="lecChange(row)"
            ></InputNumber>
          </template>
          <template slot-scope="{ row }" slot="C">
            <InputNumber
              :max="100"
              :min="0"
              v-model="row.c"
              style="margin-left: -12%"
              @on-change="lecChange(row)"
            ></InputNumber>
          </template>
          <template slot-scope="{ row }" slot="standard">
            <span v-if="row.lec < 70">稍有危险</span>
            <span v-if="row.lec > 70 && row.lec < 160">一般危险</span>
            <span v-if="row.lec >= 160 && row.lec < 320">显著危险</span>
            <span v-if="row.lec >= 320">高度危险</span>
          </template>
          <template slot-scope="{ row }" slot="riskLevel">
            <el-tag v-if="row.riskLevel === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
            <el-tag v-else-if="row.riskLevel === 3" size="small" effect="dark">低风险</el-tag>
          </template>
          <template slot-scope="{ row }" slot="isControl">
            <el-switch
              v-model="row.isControl"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
              @change="switchChange(row, 'lec')"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </Table>
        <div style="margin-top: 60px">
          <h3>事故事件发生的可能性（L）判定准则</h3>
          <el-table
            :data="tableDataLEC1"
            border
            :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%">
            <el-table-column prop="score" label="分数值" width="150px" />
            <el-table-column prop="possibility" label="事故、事件或偏差发生的可能性" />
          </el-table>
          <h3>暴露于危险环境的频繁程度（E）判定准则</h3>
          <el-table
            :data="tableDataLEC2"
            border
            :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%">
            <el-table-column prop="score" label="分数值" width="150px" />
            <el-table-column prop="frequency" label="频繁程度" />
          </el-table>
          <h3>发生事故事件偏差产生的后果严重性（C）判定准则</h3>
          <el-table
            :data="tableDataLEC3"
            border
            :header-cell-style="{ textAlign: 'center', background: 'rgb(248,248,249)', color: '#515261' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%">
            <el-table-column prop="score" label="分数值" width="150px" />
            <el-table-column prop="a" label="法律法规及其他要求" />
            <el-table-column prop="b" label="人员伤亡" />
            <el-table-column prop="c" label="直接经济损失（万元）" />
            <el-table-column prop="d" label="停工" />
            <el-table-column prop="e" label="公司形象" />
          </el-table>
        </div>
      </el-dialog>

      <!-- 固有风险的弹窗 -->
      <el-dialog title="固有风险评价：" v-if="assessmentObj.content.inherentRisk" :visible.sync="innerVisibleGY" @close="closeDiaGY"
       :fullscreen="true" append-to-body :show-close="false" :close-on-press-escape="false">
        <template>
          <Steps :current="current">
            <Step title="事故发生的可能性（L）"></Step>
            <Step title="事故后果的严重性（S）"></Step>
            <Step title="分析结果（R）"></Step>
          </Steps>
          <Table
            v-if="current == 0"
            border
            :columns="columns3"
            :data="assessmentObj.content.inherentRisk.inherentL"
            style="margin-top: 1%"
          >
            <template slot-scope="{ row }" slot="action">
              <InputNumber :max="4" :min="0" v-model="row.l" style="margin-left: -12%" @on-change="LChange(row)" />
            </template>
          </Table>
          <Table
            v-if="current == 1"
            border
            :columns="columns4"
            :data="assessmentObj.content.inherentRisk.inherentS"
            style="margin-top: 1%"
          >
            <template slot-scope="{ row }" slot="action">
              <InputNumber :max="4" :min="0" v-model="row.s" style="margin-left: -12%" @on-change="SChange(row)" />
            </template>
          </Table>
          <Table
            v-if="current == 2"
            border
            :columns="columns5"
            :data="data5"
            style="margin-top: 1%"
            :span-method="handleSpan"
          ></Table>
          <div v-if="current == 2" style="margin-left: 2%;margin-top: 1%;">
            <div>风险（R）计算：风险（R）= 事故发生的可能性（L）× 事故后果的严重性（S）</div>
            <div>
              <span>风险等级判别标准：</span>
              <ul style="margin-left: 3%">
                <li>R=1，2，3，蓝色低风险企业</li>
                <li>R=4，6，黄色一般风险企业</li>
                <li>R=8，9，橙色较大风险企业</li>
                <li>R=12，16，红色重大风险企业</li>
              </ul>
            </div>
            <div style="margin-top: 2%;font-size: 18px;">
              当前计算结果: L= {{ l }}，S={{ s }}， 
              R = L * S = {{ l*s }}
              <el-tag type="primary" v-if="l*s < 4" size="small" effect="dark">低风险</el-tag>
              <el-tag style="color: #666666;background: yellow;borderColor: yellow" v-if="l*s <8 && l*s >=4" size="small" effect="dark">一般风险</el-tag>
              <el-tag type="warning" v-if="l*s <12 && l*s >=8" size="small" effect="dark">较大风险</el-tag>
              <el-tag type="danger" v-if="l*s >=12 " size="small" effect="dark">重大风险</el-tag>
            </div>
          </div>
        </template>
          <div class="innerDia-footer-left">
            <Button :disabled="current === 0" type="primary" @click="pre">上一步</Button>
            <Button :disabled="current === 2" type="primary" @click="next" style="margin-left: 10px">下一步</Button>
          </div>
          <div class="innerDia-footer">
            <Button type="primary" @click="asyncFinish" :disabled="current !== 2">确定</Button>
          </div>
      </el-dialog>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="text" @click="closeOutDia">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { riskPointAssessment, riskPointEvaluate } from "@/api/processManager";
export default {
  name: "riskPointDia",
  props: ["showStatus", "riskPointId", "assessmentObj"],
  data() {
    return {
      outerVisble: false,
      innerVisibleLS: false,
      innerVisibleMES: false,
      innerVisibleLEC: false,
      form: {},
      newMap: null,
      // LS分析法评判标准
      tableDataLS: [
        { level: '5', standard: '在现场没有采取防范、监测、保护、控制措施，或危害的发生不能被发现（没有监测系统），或在正常情况下经常发生此类事故或事件。',
          a: '5', b: '违反法律、法规和标准', c: '死亡', d: '100万元以上', e: '部分装置（>2 套）或设备', f: '重大国际影响'
        },
        { level: '4', standard: '危害的发生不容易被发现，现场没有检测系统，也未发生过任何监测，或在现场有控制措施，但未有效执行或控制措施不当，或危害发生或预期情况下发生',
           a: '4', b: '潜在违反法规和标准', c: '丧失劳动能力', d: '50万元以上', e: '2套装置停工、或设备停工', f: '行业内、省内影响'
        },
        { level: '3', standard: '没有保护措施（如没有保护装置、没有个人防护用品等），或未严格按操作程序执行，或危害的发生容易被发现（现场有监测系统），或曾经作过监测，或过去曾经发生类似事故或事件。',
          a: '3', b: '不符合上级公司或行业的安全方针、制度、规定等', c: '截肢、骨折、听力丧失、慢性病', d: '1万元以上', e: '1 套装置停工或设备', f: '地区影响'
        },
        { level: '2', standard: '危害一旦发生能及时发现，并定期进行监测，或现场有防范控制措施，并能有效执行，或过去偶尔发生事故或事件。',
          a: '2', b: '不符合企业的安全操作程序、规定', c: '轻微受伤、间歇不舒服', d: '1万元以下', e: '受影响不大，几乎不停工', f: '公司及周边范围'
        },
        { level: '1', standard: '有充分、有效的防范、控制、监测、保护措施，或员工安全卫生意识相当高，严格执行操作规程。极不可能发生事故或事件。',
          a: '1', b: '完全符合', c: '无伤亡', d: '无损失', e: '没有停工', f: '形象没有受损'
        },
      ],
      // LS分析法的数据
      LStableData: [
        { title: "序号", type: 'index', align: "center", width: 50 },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '作业步骤' : '检查项目', key: "project", align: "center" },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '风险源或潜在事件' : '标准', key: "name", align: "center" },
        { title: '易发事故类型', key: "type", align: "center" },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '可能发生的事故描述' : '不符合标准情况', key: "riskDescription", align: "center" },
        { title: '风险要素', key: "riskFactor", align: "center" },
        { title: '后果', key: "consequence", align: "center" },
        // {
        //   title: "现有控制措施",
        //   align: "center",
        //   children: [
        //     {
        //       title: "工程技术措施",
        //       key: "technicalMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "管理措施",
        //       key: "managementMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "培训教育措施",
        //       key: "trainingMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "个体防护措施",
        //       key: "personalFenceMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "应急处置措施",
        //       key: "emergencyMeasure",
        //       align: "center"
        //     }
        //   ]
        // },
        {
          title: "风险评价",
          align: "center",
          children: [
            {
              title: "可能性（L）",
              slot: "l",
              width: 130,
              align: "center"
            },
            {
              title: "严重性（S）",
              slot: "s",
              width: 130,
              align: "center"
            },
            { title: "风险值", slot: "ls", width: 80, align: "center" },
            { title: "评价级别", slot: "standard", width: 80, align: "center" }
          ]
        },
        { title: "管控等级", slot: "riskLevel", width: 120, align: "center" },
        { title: '是否管控', slot: 'isControl', width: 120, align: 'center' }
      ],
      // MES分析法评判标准
      tableDataMES1: [
        { score: '5', status: '无控制措施' },
        { score: '3', status: '有减轻后果的应急措施，如警报系统、个体防护用品' },
        { score: '1', status: '有预防措施，如机器防护装置等，但须保证有效' },
      ],
      tableDataMES2: [
        { score: '10', a: '连续暴露', b: '常态' },
        { score: '6', a: '每天工作时间内暴露', b: '每天工作时间出现' },
        { score: '3', a: '每周一次，或偶然暴露', b: '每周一次，或偶然出现' },
        { score: '2', a: '每月一次暴露', b: '每月一次出现' },
        { score: '1', a: '每年几次暴露', b: '每年几次出现' },
        { score: '0.5', a: '更少的暴露', b: '更少的出现' },
        { score: '注1：8小时不离工作岗位，算“连续暴露”；危险状态常存，算“常态”。注2：8小时内暴露一至几次，算“每天工作时间暴露”；危险状态出现一至几次，算“每天工作时间出现”。', a: '', b: '' }
      ],
      tableDataMES3: [
        { score: '10', a: '有多人死亡', b: '', c: '＞1千万', d: '有重大环境影响的不可控排放' },
        { score: '8', a: '有一人死亡或多人永久失能', b: '职业病（多人）', c: '100万—1000万', d: '有中等环境影响的不可控排放' },
        { score: '4', a: '永久失能（一人）', b: '职业病（一人）', c: '10万—100万', d: '有较轻环境影响的不可控排放' },
        { score: '2', a: '需医院治疗，缺工', b: '职业性多发病', c: '1万—10万', d: '有局部环境影响的可控排放' },
        { score: '1', a: '轻微，仅需急救', b: '职业因素引起的身体不适', c: '＜1万', d: '无环境影响' },
        { score: '注：表中财产损失一栏的分档赋值，可根据行业和企业的特点进行适当调整。', a: '', b: '', c: '', d: '' },
      ],
      // 风险程度分析法 MES的表格
      MEStableData: [
        { title: "序号", type: 'index', align: "center", width: 50 },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '作业步骤' : '检查项目', key: "project", align: "center" },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '风险源或潜在事件' : '标准', key: "name", align: "center" },
        { title: '易发事故类型', key: "type", align: "center" },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '可能发生的事故描述' : '不符合标准情况', key: "riskDescription", align: "center" },
        { title: '风险要素', key: "riskFactor", align: "center" },
        { title: '后果', key: "consequence", align: "center" },
        // {
        //   title: "现有控制措施",
        //   align: "center",
        //   children: [
        //     {
        //       title: "工程技术措施",
        //       key: "technicalMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "管理措施",
        //       key: "managementMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "培训教育措施",
        //       key: "trainingMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "个体防护措施",
        //       key: "personalFenceMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "应急处置措施",
        //       key: "emergencyMeasure",
        //       align: "center"
        //     }
        //   ]
        // },
        { title: "状态（M）", slot: "M", width: 130, align: "center" },
        { title: "频次（E）", slot: "E", width: 130, align: "center" },
        { title: "严重性（S）", slot: "S", width: 130, align: "center" },
        { title: "风险值", key: "mes", width: 80, align: "center" },
        { title: "评价级别", slot: "standard", width: 120, align: "center" },
        { title: "管控等级", slot: "riskLevel", width: 120, align: "center" },
        { title: '是否管控', slot: 'isControl', width: 120, align: 'center' }
      ],
      // LEC评判标准
      tableDataLEC1: [
        { score: '10', possibility: '完全可以预料' },
        { score: '6', possibility: '相当可能；或危害的发生不能被发现（没有监测系统）；或在现场没有采取防范、监测、保护、控制措施；或在正常情况下经常发生此类事故、事件或偏差' },
        { score: '3', possibility: '可能，但不经常；或危害的发生不容易被发现；现场没有检测系统或保护措施（如没有保护装置、没有个人防护用品等），也未作过任何监测；或未严格按操作规程执行；或在现场有控制措施，但未有效执行或控制措施不当；或危害在预期情况下发生' },
        { score: '1', possibility: '可能性小，完全意外；或危害的发生容易被发现；现场有监测系统或曾经作过监测；或过去曾经发生类似事故、事件或偏差；或在异常情况下发生过类似事故、事件或偏差' },
        { score: '0.5', possibility: '很不可能，可以设想；危害一旦发生能及时发现，并能定期进行监测' },
        { score: '0.2', possibility: '极不可能；有充分、有效的防范、控制、监测、保护措施；或员工安全卫生意识相当高，严格执行操作规程' },
        { score: '0.1', possibility: '实际不可能' },
      ],
      tableDataLEC2: [
        { score: '10', frequency: '连续暴露' },
        { score: '6', frequency: '每天工作时间内暴露' },
        { score: '3', frequency: '每周一次或偶然暴露' },
        { score: '2', frequency: '每月一次暴露' },
        { score: '1', frequency: '每年几次暴露' },
        { score: '0.5', frequency: '非常罕见地暴露' },
      ],
      tableDataLEC3: [
        { score: '100', a: '严重违反法律法规和标准', b: '10人以上死亡，或50人以上重伤', c: '5000以上', d: '公司停产', e: '重大国际、国内影响' },
        { score: '40', a: '违反法律法规和标准', b: '3人以上10人以下死亡，或10人以上50人以下重伤', c: '1000以上', d: '装置停工', e: '行业内、省内影响' },
        { score: '15', a: '潜在违反法规和标准', b: '3人以下死亡，或10人以下重伤', c: '100以上', d: '部分装置停工', e: '地区影响' },
        { score: '7', a: '不符合上级或行业的安全方针、制度、规定等', b: '丧失劳动力、截肢、骨折、听力丧失、慢性病', c: '10万以上', d: '部分设备停工', e: '公司及周边范围' },
        { score: '2', a: '不符合公司的安全操作程序、规定', b: '轻微受伤、间歇不舒服', c: '1万以上', d: '1套设备停工', e: '引人关注，不利于基本的安全卫生要求' },
      ],
      // 风险程度分析法 LEC的表格
      LECtableData: [
        { title: "序号", type: 'index', align: "center", width: 50 },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '作业步骤' : '检查项目', key: "project", align: "center" },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '风险源或潜在事件' : '标准', key: "name", align: "center" },
        { title: '易发事故类型', key: "type", align: "center" },
        { title: this.assessmentObj.analyticalMethodClassify === 1 ? '可能发生的事故描述' : '不符合标准情况', key: "riskDescription", align: "center" },
        { title: '风险要素', key: "riskFactor", align: "center" },
        { title: '后果', key: "consequence", align: "center" },
        // {
        //   title: "现有控制措施",
        //   align: "center",
        //   children: [
        //     {
        //       title: "工程技术措施",
        //       key: "technicalMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "管理措施",
        //       key: "managementMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "培训教育措施",
        //       key: "trainingMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "个体防护措施",
        //       key: "personalFenceMeasure",
        //       align: "center"
        //     },
        //     {
        //       title: "应急处置措施",
        //       key: "emergencyMeasure",
        //       align: "center"
        //     }
        //   ]
        // },
        { title: "状态（L）", slot: "L", width: 130, align: "center" },
        { title: "频次（E）", slot: "E", width: 130, align: "center" },
        { title: "严重性（C）", slot: "C", width: 130, align: "center" },
        { title: "风险值", key: "lec", width: 80, align: "center" },
        { title: "评价级别", slot: "standard", width: 120, align: "center" },
        { title: "管控等级", slot: "riskLevel", width: 120, align: "center" },
        { title: '是否管控', slot: 'isControl', width: 120, align: 'center' }
      ],
      // 固有风险的弹窗
      innerVisibleGY: false,
      current: 0,
      columns3: [
        { title: "序号", type: "index", align: "center", width: 50 },
        { title: "项目", key: "project", align: "center" },
        {
          title: "取值标准",
          align: "center",
          children: [
            {
              title: "1",
              key: "l1",
              align: "center"
            },
            {
              title: "2",
              key: "l2",
              align: "center"
            },
            {
              title: "3",
              key: "l3",
              align: "center"
            },
            {
              title: "4",
              key: "l4",
              align: "center"
            }
          ]
        },
        { title: "Ln", key: "ln", width: 80, align: "center" },
        { title: "L", slot: "action", width: 100, align: "center" }
      ],
      columns4: [
        { title: "序号", type: "index", align: "center", width: 50 },
        { title: "项目", key: "project", align: "center" },
        {
          title: "取值标准",
          align: "center",
          children: [
            {
              title: "1",
              key: "s1",
              align: "center"
            },
            {
              title: "2",
              key: "s2",
              align: "center"
            },
            {
              title: "3",
              key: "s3",
              align: "center"
            },
            {
              title: "4",
              key: "s4",
              align: "center"
            }
          ]
        },
        { title: "Sn", key: "sn", width: 80, align: "center" },
        { title: "S", slot: "action", width: 100, align: "center" }
      ],
      columns5: [
        {
          title: "风险矩阵（R）",
          align: "center",
          children: [
            {
              key: "col1",
              align: "center"
            },
            {
              key: "col2",
              align: "center"
            }
          ]
        },
        {
          title: "事故后果的严重性（S）",
          align: "center",
          children: [
            {
              title: "1",
              key: "col3",
              align: "center"
            },
            {
              title: "2",
              key: "col4",
              align: "center"
            },
            {
              title: "3",
              key: "col5",
              align: "center"
            },
            {
              title: "4",
              key: "col6",
              align: "center"
            },
          ]
        }
      ],
      data5: [
        {
          col1: "事故发生的可能性（L）",
          col2: "1",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          col7: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myBlue",
            col5: "myBlue",
            col6: "myYellow"
          }
        },
        {
          col1: "事故发生的可能性（L）",
          col2: "2",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          col7: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myYellow",
            col5: "myYellow",
            col6: "myNotRed"
          }
        },
        {
          col1: "事故发生的可能性（L）",
          col2: "3",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          col7: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myYellow",
            col5: "myNotRed",
            col6: "myRed"
          }
        },
        {
          col1: "事故发生的可能性（L）",
          col2: "4",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          col7: "",
          cellClassName: {
            col3: "myYellow",
            col4: "myNotRed",
            col5: "myRed",
            col6: "myRed"
          }
        },
      ],
      l: 0,
      s: 0,
    };
  },
  created() {
    this.newMap = new Map(
      [
        ['0', '稍有危险'], ['1', '稍有危险'], ['2', '稍有危险'],['3', '稍有危险'],['4', '轻度危险'],
        ['5', '轻度危险'], ['6', '轻度危险'], ['7', '轻度危险'],['8', '轻度危险'],['9', '显著危险'],
        ['10', '显著危险'], ['12', '显著危险'], ['15', '高度危险'],['16', '高度危险'],['20', '及其危险'],
        ['25', '及其危险']
      ]
    );
    this.outerVisble = this.showStatus;
  },
  methods: {
    // 关闭弹窗
    closeOutDia() {
      this.$emit("backStatus", { status: false });
    },
    // 外层弹窗的确定按钮(提交表单)
    submitForm() {
      if(this.assessmentObj.analyticalMethod === '100') {
        this.assessmentObj.content.lsValue = this.assessmentObj.content.inherentRisk.lsvalue
      }
      riskPointEvaluate({ nextEvaluationTime: this.form.nextEvaluationTime, id: this.riskPointId, riskEvaluateJson: this.assessmentObj.content }).then(res => {
        this.$message.success('评价成功');
         this.$emit("backStatus", { status: false, refresh: true });
      })
    },
    // 检查该评价方法是否显示
    checkMethods(val, val2) {
      let str = this.assessmentObj.analyticalMethod;
      if (str) {
        if (val === "LS") {
          if (val2 === 0) {
            if ((str.indexOf("1") != -1 || str.indexOf("4") != -1) && str === '100') {
              return true;
            }
          }
          if(val2 === 1) {
            if((str.indexOf("1") != -1 || str.indexOf("4") != -1) && str !== '100') {
              return true
            }
          }
        } else if (val === "MES") {
          if (str.indexOf("3") != -1 || str.indexOf("6") != -1) {
            return true;
          }
        } else if (val === "LEC") {
          if (str.indexOf("2") != -1 || str.indexOf("5") != -1) {
            return true;
          }
        }
      }
      return false;
    },
    // ls评价按钮的事件
    lsBtn() {
      if (this.assessmentObj.analyticalMethod === '100') {
        this.innerVisibleGY = true
      } else {
        this.innerVisibleLS = true;
      }
    },
    // LS分析法的数字输入框改变的事件
    lChange(row) {
      let ls = row.l * row.s
      row.ls = row.l * row.s
      for(let i in this.assessmentObj.content.ls) {
        if(row.id === this.assessmentObj.content.ls[i].id) {
          this.assessmentObj.content.ls[i].l = row.l
          this.assessmentObj.content.ls[i].s = row.s
          this.assessmentObj.content.ls[i].ls = ls
          if(ls <= 8) {
            this.assessmentObj.content.ls[i].riskLevel = 3
          }
          if(ls >8 && ls <= 12) {
            this.assessmentObj.content.ls[i].riskLevel = 2
          }
          if(ls >= 15 && ls <= 16) {
            this.assessmentObj.content.ls[i].riskLevel = 1
          }
          if(ls >= 20 && ls <= 25) {
            this.assessmentObj.content.ls[i].riskLevel = 0
          }
        }
      }
      this.$forceUpdate()
    },
    // 是否管控  开关状态改变的事件
    switchChange(row, status) {
      if(status === 'ls') {
        for(let i in this.assessmentObj.content.ls) {
          if(row.id === this.assessmentObj.content.ls[i].id) {
            this.assessmentObj.content.ls[i].isControl = row.isControl
          }
        }
      }
      if(status === 'mes') {
        for(let i in this.assessmentObj.content.mes) {
          if(row.id === this.assessmentObj.content.mes[i].id) {
            this.assessmentObj.content.mes[i].isControl = row.isControl
          }
        }
      }
      if(status === 'lec') {
        for(let i in this.assessmentObj.content.lec) {
          if(row.id === this.assessmentObj.content.lec[i].id) {
            this.assessmentObj.content.lec[i].isControl = row.isControl
          }
        }
      }
    },
    // 关闭LS分析法的弹窗
    closeDiaLS() {
      let num = 3
      for(let i in this.assessmentObj.content.ls) {
        if(num >= this.assessmentObj.content.ls[i].riskLevel) {
          num = this.assessmentObj.content.ls[i].riskLevel
        }
      }
      this.$set(this.assessmentObj.content, 'lsValue', num)
      this.innerVisibleLS = false;
    },
    // MES 表格合并
    spanMethodMES1({ row, column, rowIndex, columnIndex }) {
      if(rowIndex === 6) {
        return [ 1,3 ]
      }
    },
    spanMethodMES2({ row, column, rowIndex, columnIndex }) {
      if(rowIndex === 5) {
        return [ 1,5 ]
      }
    },
    // MES 分析法输入框改变时的事件
    mesChange(row) {
      let mes = row.m * row.e * row.s;
      row.mes = mes;
      for(let i in this.assessmentObj.content.mes) {
        if(this.assessmentObj.content.mes[i].id === row.id) {
          this.assessmentObj.content.mes[i].m = row.m
          this.assessmentObj.content.mes[i].e = row.e
          this.assessmentObj.content.mes[i].s = row.s
          this.assessmentObj.content.mes[i].mes = mes
          if(mes <= 50) {
            this.assessmentObj.content.mes[i].riskLevel = 3
            row.riskLevel = 3
          }
          if(mes > 50 && mes <= 90) {
            this.assessmentObj.content.mes[i].riskLevel = 2
            row.riskLevel = 2
          }
          if(mes > 90 && mes <= 180) {
            this.assessmentObj.content.mes[i].riskLevel = 1
            row.riskLevel = 1
          }
          if(mes > 180) {
            this.assessmentObj.content.mes[i].riskLevel = 0
            row.riskLevel = 0
          }
        }
      }
      this.$forceUpdate()
    },
    // 关闭MES分析法的弹窗
    closeDiaMES() {
      let num = 3
      for(let i in this.assessmentObj.content.mes) {
        if(num >= this.assessmentObj.content.mes[i].riskLevel) {
          num = this.assessmentObj.content.mes[i].riskLevel
        }
      }
      this.$set(this.assessmentObj.content, 'mesValue', num)
      this.innerVisibleMES = false;
    },
    // LEC 分析法输入框改变时的事件
    lecChange(row) {
      let lec = row.l * row.e * row.c;
      row.lec = lec;
      for(let i in this.assessmentObj.content.lec) {
        if(this.assessmentObj.content.lec[i].id === row.id) {
          this.assessmentObj.content.lec[i].l = row.l
          this.assessmentObj.content.lec[i].e = row.e
          this.assessmentObj.content.lec[i].c = row.c
          this.assessmentObj.content.lec[i].lec = lec
          if(lec < 70) {
            this.assessmentObj.content.lec[i].riskLevel = 3
            row.riskLevel = 3
          }
          if(lec > 70 && lec < 160) {
            this.assessmentObj.content.lec[i].riskLevel = 2
            row.riskLevel = 2
          }
          if(lec >= 160 && lec < 320) {
            this.assessmentObj.content.lec[i].riskLevel = 1
            row.riskLevel = 1
          }
          if(lec >= 320) {
            this.assessmentObj.content.lec[i].riskLevel = 0
            row.riskLevel = 0
          }
        }
      }
      this.$forceUpdate()
    },
    // 关闭LEC分析法的弹窗
    closeDiaLEC() {
      let num = 3
      for(let i in this.assessmentObj.content.lec) {
        if(num >= this.assessmentObj.content.lec[i].riskLevel) {
          num = this.assessmentObj.content.lec[i].riskLevel
        }
      }
      this.$set(this.assessmentObj.content, 'lecValue', num)
      this.innerVisibleLEC = false;
    },

    // 固有风险的弹窗事件
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 0) {
        return [4, 1];
      }
      if (rowIndex === 1 && columnIndex === 0) {
        return [0, 0];
      }
      if (rowIndex === 2 && columnIndex === 0) {
        return [0, 0];
      }
      if (rowIndex === 3 && columnIndex === 0) {
        return [0, 0];
      }
    },
    // 数字输入框改变的事件
    LChange(row) {
      for(let i in this.assessmentObj.content.inherentRisk.inherentL) {
        if(row.project === this.assessmentObj.content.inherentRisk.inherentL[i].project) {
          this.assessmentObj.content.inherentRisk.inherentL[i].l = row.l
        }
      }
    },
    SChange(row) {
      for(let i in this.assessmentObj.content.inherentRisk.inherentS) {
        if(row.project === this.assessmentObj.content.inherentRisk.inherentS[i].project) {
          this.assessmentObj.content.inherentRisk.inherentS[i].s = row.s
        }
      }
    },
    // 上一步下一步的按钮
    pre() {
      if(this.current > 0) {
        this.current -= 1
      }
    },
    next() {
      if(this.current < 3) {
        if(this.current === 1) {
          let l = 0;
          let lCum = 0;
          let s = 0;
          // 算出l表里面的平均值（向上取整）
          for(let i in this.assessmentObj.content.inherentRisk.inherentL) {
            if(this.assessmentObj.content.inherentRisk.inherentL[i].l != 0) {
              l += this.assessmentObj.content.inherentRisk.inherentL[i].l
              lCum += 1
            }
          }
          // 取出s表里面的最大值
          for(let j in this.assessmentObj.content.inherentRisk.inherentS) {
            if(this.assessmentObj.content.inherentRisk.inherentS[j].s > s) {
              s = this.assessmentObj.content.inherentRisk.inherentS[j].s
            }
          }
          if (lCum === 0) {
            this.l = 0
          } else {
            this.l = Math.ceil(l / lCum)
          }
          this.s = s
        }
        this.current += 1
      }
    },
    // 固有风险评价弹窗关闭的事件
    closeDiaGY() {
      let num = this.l * this.s
      if(num < 4) {
        this.assessmentObj.content.inherentRisk.lsvalue = 3
      } else if(num >= 4 && num < 8) {
        this.assessmentObj.content.inherentRisk.lsvalue = 2
      } else if(num >= 8 && num < 12) {
        this.assessmentObj.content.inherentRisk.lsvalue = 1
      } else {
        this.assessmentObj.content.inherentRisk.lsvalue = 0
      }
      this.innerVisibleGY = false;
    },
    // 固有风险弹窗确定按钮
    asyncFinish() {
      this.closeDiaGY();
    }
  }
};
</script>

<style scoped>
.riskPointDiaBox /deep/ .el-dialog {
  border-radius: 8px;
  margin-bottom: 20px
}
.riskPointDiaBox /deep/ .el-dialog__header {
  border-bottom: 1px solid #dddddd;
  padding: 15px 15px 10px 15px;
}
.riskPointDiaBox /deep/ .el-dialog__title {
  font-size: 16px;
}
.riskPointDiaBox /deep/ .el-dialog__footer {
  border-top: 1px solid #dddddd;
  padding-bottom: 10px;
}
.assBtn {
  margin-left: 15px
}
.innerDia-footer {
  position: fixed;
  bottom: 10px;
  right: 15px;
}
.innerDia-footer-left {
  position: fixed;
  bottom: 10px;
  left: 25px;
}
h3 {
  margin-top: 25px
}
.mesTableBox {
  /* display: flex;
  justify-content: space-between; */
  margin-top: 60px
}
/* .mesTableBox > div {
  width: 48%
} */
/deep/.myBlue {
  background-color: #409eff;
}
/deep/.myYellow {
  background-color: yellow
}
/deep/.myNotRed {
  background-color: #E6A23C
}
/deep/.myRed {
  background-color: #F56C6C
}
</style>